module.exports = __webpack_public_path__ + "static/img/title-button1.e3c6a38f.png";